import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string | number) {
    return new Date(date).toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
}

export function doublePrice(priceString: string): string {
    const match = priceString.match(/[\d,.]+/);
    if (!match) return priceString;

    const numericValue = match[0].replace(/,/g, "");
    const price = Number.parseFloat(numericValue);
    const doubledPrice = (price * 2).toFixed(2);

    const currencySymbol = priceString.replace(/[\d,.\s]/g, "");

    if (match[0].includes(",")) {
        const [intPart, decPart] = doubledPrice.split(".");
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${currencySymbol}${formattedInt}${decPart ? `.${decPart}` : ""}`;
    }

    return `${currencySymbol}${doubledPrice}`;
}
